export const getFormattedInputValue = (value: string): string => {
    const digit = value.replace(/\D/g, '').slice(0, 10);
    let res = '';
    if (digit.length > 0) {
      res = `${digit.slice(0, 3)}`;
    }
    if (digit.length >= 4) {
      res = `(${res}) ${digit.slice(3, 6)}`;
    }
    if (digit.length >= 7) {
      res += `-${digit.slice(6)}`;
    }
    return res;
  };